angular.module('forms').directive('apFormQuestionFamilyHistory',[
        '$q',
        '$rootScope',
        '$uibModal',
        'FormsId',
        'FormsService',
        'ListService',
        function (
            $q,
            $rootScope,
            $modal,
            FormsId,
            FormsService,
            ListService
            ) {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: '/forms/views/directives/apFormQuestionFamilyHistory.html',
                scope: {
                    // Use '@' for one way binding.  String value is returned.
                    // Use '=' for two way binding.  An object is returned.
                    // Use '&' for a method.
                    questionnaireSectionId: '=questionnaireSectionId',
                    questionnaireSection: '=questionnaireSection',
                    loading: '=loading'
                },
                controller: function apFormQuestionFamilyHistoryCtrl($scope) {
                    $scope.currentSectionId = '';

                    var historyRelationshipList = '';
                    var familyHxRelationshipList = '';


                    $scope.$watch('questionnaireSectionId', function() {
                        if ($scope.currentSectionId === '') {
                            return;
                        }

                        if ($scope.currentSectionId !== $scope.questionnaireSectionId) {
                            loadView();
                        }
                    });


                    function getFamilyHxProblemList(familyHxProblemId) {
                        return ListService.getList('subfindtableitems/family-history-problem/' + familyHxProblemId)
                            .then(function (data) {
                                $scope.familyHxProblemList = data;
                            });
                    }


                    function getHistoryRelationshipList() {
                        return ListService.getList('history-relationship')
                            .then(function (data) {
                                historyRelationshipList = data;
                            });
                    }


                    function getFamilyHxRelationshipList(subFindTableId) {
                        return ListService.getList('subfindtableitems/family-history-relationship/' + subFindTableId)
                            .then(function (data) {
                                familyHxRelationshipList = _(data)
                                    .forEach(function (item) {
                                        item.IsVisible = true;
                                    });
                            });
                    }


                    function setAllfamilyHxRelationshipListItemsToVisible() {
                        _.forEach(familyHxRelationshipList, function(item) {
                            item.IsVisible = true;
                        });
                    }


                    function setFamilyHxRelationshipListBasedOnMultipleUsage(patientFamilyHistoryId) {
                        _.forEach($scope.questionnaireSection.FamilyHistoryAnswers, function(fhAnswer) {
                            if (fhAnswer.PatientFamilyHistoryId !== patientFamilyHistoryId) {
                                var hxRelationshipItem =  _.find(historyRelationshipList, {Id: fhAnswer.RelationshipId});
                                if (hxRelationshipItem && hxRelationshipItem.AllowMultipleUsage === false) {
                                    var familyHxRelationshipItem = _.find(familyHxRelationshipList, {ItemId: hxRelationshipItem.Id});
                                    if (familyHxRelationshipItem) {
                                        familyHxRelationshipItem.IsVisible = false;
                                    }
                                }
                            }
                        });
                    }


                    function loadView() {
                        $rootScope.setupDirectiveScope($scope);
                        $scope.removeHttpError();
                        var familyHxProblemListPromise = getFamilyHxProblemList($scope.questionnaireSection.FamilyHxProblemSubFindTableId);
                        var historyRelationshipListPromise = getHistoryRelationshipList();
                        var familyHxRelationshipListPromise = getFamilyHxRelationshipList($scope.questionnaireSection.FamilyHxRelationshipSubFindTableId);

                        $q.all([familyHxProblemListPromise, historyRelationshipListPromise, familyHxRelationshipListPromise]).then(function () {
                            $scope.currentSectionId = $scope.questionnaireSectionId;

                            _.forEach($scope.questionnaireSection.FamilyHistoryAnswers, function(familyHistoryAnswer) {
                                var selectedRelationship = _.find(familyHxRelationshipList, {ItemId: familyHistoryAnswer.RelationshipId});
                                if (selectedRelationship === undefined) {
                                    var relationshipToAdd = _.find(historyRelationshipList, {Id: familyHistoryAnswer.RelationshipId});
                                    if (relationshipToAdd) {
                                        var newItem = {
                                            ItemId: relationshipToAdd.Id,
                                            Name: relationshipToAdd.Name,
                                            SubFindTableId: '00000000-0000-0000-0000-000000000000',
                                            SubFindTableItemId: '00000000-0000-0000-0000-000000000000',
                                            IsVisible: true
                                        };
                                        familyHxRelationshipList.push(newItem);
                                    }
                                }
                            });
                        }).catch(function (response) {
                            $scope.addHttpError(response, '', 'listData');
                        }).finally(function () {
                            $scope.loading = false;
                        });
                    }
                    loadView();


                    function getNewProblemHistoryAnswers(problemHistoryAnswers) {
                        _.forEach($scope.familyHxProblemList, function(findTableItem) {
                            problemHistoryAnswers
                                .push(FormsService.getNewProblemHistoryAnswer(
                                    findTableItem.SubFindTableItemId,                // PK for SubFindTableTime table
                                    $scope.questionnaireSection.HistoryGroupId,
                                    findTableItem.ItemId,                            // disease Id
                                    findTableItem.Name));                            // disease name
                        });
                    }


                    $scope.addFamilyHistoryInformation = function addFamilyHistoryInformation() {
                        setAllfamilyHxRelationshipListItemsToVisible();
                        setFamilyHxRelationshipListBasedOnMultipleUsage('0');

                        var familyHistoryAnswer = FormsService.getNewFamilyHistoryAnswer();
                        getNewProblemHistoryAnswers(familyHistoryAnswer.ProblemHistoryAnswers);

                        var modalInstance = $modal.open({
                            templateUrl: '/forms/views/updateFamilyHistoryModal.html',
                            controller:  'UpdateFamilyHistoryModalCtrl',
                            scope: $scope,
                            //size: 'lg',
                            windowClass: 'modal-full',
                            resolve: {
                                FamilyHxRelationshipId: function() {
                                    return $scope.questionnaireSection.FamilyHxRelationshipSubFindTableId;
                                },
                                FamilyHistoryAnswer: function() {
                                    return familyHistoryAnswer;
                                },
                                HistoryRelationshipList: function() {
                                    return familyHxRelationshipList;
                                }
                            }
                        });

                        modalInstance.result.then(function (result) {
                            if (result === FormsId.ModalInstanceReturnId.Accept) {
                                $scope.questionnaireSection.FamilyHistoryAnswers.push(familyHistoryAnswer);
                            }
                        });
                    };


                    $scope.EditFamilyHistoryAnswer = function EditFamilyHistoryAnswer(familyHistoryAnswer) {
                        setAllfamilyHxRelationshipListItemsToVisible();
                        setFamilyHxRelationshipListBasedOnMultipleUsage(familyHistoryAnswer.PatientFamilyHistoryId);

                        $modal.open({
                            templateUrl: '/forms/views/updateFamilyHistoryModal.html',
                            controller:  'UpdateFamilyHistoryModalCtrl',
                            scope: $scope,
                            //size: 'lg',
                            windowClass: 'modal-full',
                            resolve: {
                                FamilyHxRelationshipId: function() {
                                    return $scope.questionnaireSection.FamilyHxRelationshipSubFindTableId;
                                },
                                FamilyHistoryAnswer: function() {
                                    return familyHistoryAnswer;
                                },
                                HistoryRelationshipList: function() {
                                    return familyHxRelationshipList;
                                }
                            }
                        });
                    };


                    $scope.DeleteFamilyHistoryAnswer = function DeleteFamilyHistoryAnswer(familyHistoryAnswer) {
                        _.pull($scope.questionnaireSection.FamilyHistoryAnswers, familyHistoryAnswer);
                    };

                }
            };
        }
    ]
);